import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-success text-white pt-5 pb-4 mt-5">
      <div className="container">
        {/* RIGA 1 */}
        <div className="row mb-4">
          <div className="col-md-4">
            <h5 className="fw-bold">Iovendosiciliano</h5>
            <p className="small">
              Vendiamo e promuoviamo prodotti siciliani di alta qualità.
              Un assaggio di Sicilia a portata di click!
            </p>
          </div>
          <div className="col-md-4">
            <h5 className="fw-bold">Links</h5>
            <ul className="list-unstyled">
              <li><a href="/" className="text-white text-decoration-none">Home</a></li>
              <li><a href="/products" className="text-white text-decoration-none">Products</a></li>
              <li><a href="/about" className="text-white text-decoration-none">About Us</a></li>

            </ul>
          </div>
          <div className="col-md-4">
            <h5 className="fw-bold">Contatti</h5>
            <p className="small mb-1">
              <i className="fas fa-map-marker-alt me-2"></i>
              Palermo, Sicilia
            </p>
            <p className="small mb-1">
              <i className="fas fa-phone me-2"></i>
              +39 0123 456789
            </p>
            <p className="small mb-1">
              <i className="fas fa-envelope me-2"></i>
              info@iovendo.it
            </p>
          </div>
        </div>

        <hr className="border-light" />

        {/* RIGA 2: Social Icons e diritti */}
        <div className="row align-items-center">
          <div className="col-md-6 text-center text-md-start mb-2 mb-md-0">
            <p className="mb-0 small">
              &copy; 2025 Iovendosiciliano. All rights reserved.
            </p>
          </div>
          <div className="col-md-6 text-center text-md-end">
            {/* Social Icons */}
            <a
              href="https://www.tiktok.com/"
              className="text-white me-3 text-decoration-none"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-tiktok fa-lg"></i>
            </a>
            <a
              href="https://www.instagram.com/"
              className="text-white me-3 text-decoration-none"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-instagram fa-lg"></i>
            </a>
            <a
              href="https://www.linkedin.com/"
              className="text-white me-3 text-decoration-none"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-linkedin-in fa-lg"></i>
            </a>
            <a
              href="https://www.facebook.com/"
              className="text-white me-3 text-decoration-none"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-facebook-f fa-lg"></i>
            </a>
            <a
              href="https://twitter.com/"
              className="text-white text-decoration-none"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-twitter fa-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
